import type { ConsentEntry } from "@/shared/types/probateTypes";

export function parseConsentEntries(
  raw: string | string[] | undefined,
): Record<string, ConsentEntry> {
  if (!raw || Array.isArray(raw)) return {};
  try {
    const parsed: unknown = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed as Record<string, ConsentEntry>;
    }
    return {};
  } catch {
    return {};
  }
}

export function parseJsonIds(raw: string | string[] | undefined): number[] {
  if (typeof raw !== "string" || !raw) return [];
  try {
    return JSON.parse(raw) as number[];
  } catch {
    return [];
  }
}
